import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CNAEFormControlTextModule } from '../form-control-text';
import { CNAETableViewModule } from '../table-view';
import { CNAEsViewComponent } from './cnaes-view.component';

@NgModule({
    imports: [
        SharedModule,
        CNAEFormControlTextModule,
        CNAETableViewModule
    ],
    declarations: [
        CNAEsViewComponent
    ],
    exports: [
        CNAEsViewComponent
    ]
})
export class CNAEsViewModule { }
